import React from 'react';
import AdminRoutes from './routes/AdminRoutes';

/**
 * AdminContainer serves as the single entry point for the admin section
 * It provides a simplified wrapper around AdminRoutes
 */
const AdminContainer: React.FC = () => {
  // Render the admin routes directly without additional logic
  return <AdminRoutes />;
};

export default AdminContainer;
